var _style, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTabMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#999999;}\n\t.st1{display:none;}\n\t.st2{display:inline;}\n\t.st3{fill:none;stroke:#999999;}\n\t.st4{display:inline;fill:none;stroke:#000222;}\n\t.st5{fill:#000222;}\n\t.st6{fill:#FFFFFF;stroke:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.7,20.5H5.3c-1.4,0-2.5-1.1-2.5-2.5V6.6h16c1.4,0,2.5,1.1,2.5,2.5V18C21.2,19.4,20.1,20.5,18.7,20.5z  M3.8,7.6V18c0,0.8,0.7,1.5,1.5,1.5h13.5c0.8,0,1.5-0.7,1.5-1.5V9.1c0-0.8-0.7-1.5-1.5-1.5H3.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.9,7.6H2.8V6c0-1.4,1.1-2.5,2.5-2.5h11.1c1.4,0,2.5,1.1,2.5,2.5V7.6z M3.8,6.6h14.1V6 c0-0.8-0.7-1.5-1.5-1.5H5.3C4.4,4.5,3.8,5.2,3.8,6V6.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.8,15c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4S17.6,15,16.8,15z M16.8,13.1 c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4S17,13.1,16.8,13.1z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3.3,7.1h15.5c1.1,0,2,0.9,2,2V18c0,1.1-0.9,2-2,2H5.3c-1.1,0-2-0.9-2-2V7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3.3,6c0-1.1,0.9-2,2-2h11.1c1.1,0,2,0.9,2,2v1.1H3.3V6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 16.8,
    cy: 13.6,
    r: 0.9
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_3",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M3.3,7.2h15.5c1.1,0,2,0.9,2,2v8.9c0,1.1-0.9,2-2,2H5.3c-1.1,0-2-0.9-2-2V7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M3.3,6.1c0-1.1,0.9-2,2-2h11.1c1.1,0,2,0.9,2,2v1.1H3.3V6.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M3.3,7.2h15.5c1.1,0,2,0.9,2,2v8.9c0,1.1-0.9,2-2,2H5.3c-1.1,0-2-0.9-2-2V7.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 16.8,
    cy: 13.6,
    r: 0.9
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTabMain);
export default __webpack_public_path__ + "static/media/icon-tab-main.09b8c6ad623c817cdf8a79ad5ac58300.svg";
export { ForwardRef as ReactComponent };